export const OBSERVATION_CONNECTIONS = 'OBSERVATION_CONNECTIONS';
export const CLEAR_CONNECTIONS = 'clearConnections';
